
import { useState } from "react";
import { Typography, Card, Divider } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import MessageError from "../../../messages/messageError";
import { useNavigate, useParams } from "react-router-dom";
import FazerObservacoes from "../../components/fazerObservacoes.";
import api from "../../../services/api";
import * as yup from 'yup'; // VALIDACAO
import RegisterAccess from "../../../utils/registerAccess";
import ButtonLeft from "../../../utils/buttonLeft";


export default function ChangeStatusControleQualidade({ setSolicitacaoAnalise }) {
    const { id } = useParams()
    const { action } = useParams()
    const { status } = useParams()
    const navigate = useNavigate()
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);
    const dispatch = useDispatch()


    const handleChangeStatus = (assunto) => {
        setOpen(true)
        api.patch('/solicitacao-analise/change-status', {
            status: status,
            // status: 'Reprovado',
            solicitacaoAnaliseId: id,
            userId: user?._id,
            observacao: obs
        }).then(response => {

            dispatch({
                type: 'alert',
                payload: { alert: 'Solicitação encaminhada com sucesso.!' },
            });
            // console.log(response.data);
            setSolicitacaoAnalise(response.data.solicitacaoAnalise);
            // navigate(`/admin/dcqmts/gest/solicitacao-de-analise/${id}`)
            // redirecionar para a pagina anterior, que pode ser a lista de inscritos ou a ficha de inscrição, dependendo de onde o admin veio
            navigate(localStorage.getItem('urlAnterior') || -1);
        }).catch(error => {
            setMessageError(error.response.data.message)
        }).finally(() => setOpen(false))
    }

    async function validate() {
        setMessageError('');

        let schema = yup.object().shape({
            observacao: yup.string("Necessário inserir as observações").required("Necessário inserir observações"),
        })

        try {
            await schema.validate({ 'observacao': obs })
            handleChangeStatus()
        } catch (error) {
            setMessageError(error.errors);
        }
        return false
    }


    return (
        <Card style={{ padding: 20, paddingBottom: 30 }}>
            <RegisterAccess page={'alteração de estado de solicitacao de importação'} />
            {messageError && <MessageError message={messageError} />}

            <div style={{ marginBottom: 30 }}>
                <Typography style={{ lineHeight: 1.5 }} variant="h5">
                    Confirmação de
                    {action === 'approve' ? ' aprovação' : ' reprovação'}
                </Typography>

                <Divider />

                {action === 'approve' &&
                    <Typography >
                        Ao confirmar esta ação estarás a afirmar que análisaste correctamente
                        toda informação e documentos anexado neste processo estão em conformidade!
                    </Typography>
                }

                <FazerObservacoes setObs={setObs} obs={obs} titulo={action === 'approve' ? '(caso seja necessário fazer alguma observação)' : '(Descreve os motivos desta reprovação)'} />

                <ButtonLeft
                    funcao={action === 'approve' ? handleChangeStatus : validate}
                    title={'Confirmar'}
                    load={open}
                >
                    <Button color="error" onClick={() => navigate(`/admin/dcqmts/gest/solicitacao-de-analise/${id}`)} >Cancelar</Button>
                </ButtonLeft>
            </div>
        </Card>
    )
}